var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgIconChannel = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 16,
  height: 16,
  viewBox: "0 0 28.125 22.5"
}, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
  id: "Group_4985",
  "data-name": "Group 4985",
  transform: "translate(0 0)"
}, /*#__PURE__*/React.createElement("g", {
  id: "Group_4965",
  "data-name": "Group 4965",
  transform: "translate(0 0)"
}, /*#__PURE__*/React.createElement("path", {
  id: "Path_5533",
  "data-name": "Path 5533",
  d: "M18.516,18.031a3.516,3.516,0,1,1,3.516-3.516,3.52,3.52,0,0,1-3.516,3.516m0-4.219a.7.7,0,1,0,.7.7.7.7,0,0,0-.7-.7",
  transform: "translate(-4.453 -3.266)"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_5534",
  "data-name": "Path 5534",
  d: "M29.408,22.5a1.406,1.406,0,0,1-.747-2.6,10.238,10.238,0,0,0,4.964-8.651A10.239,10.239,0,0,0,28.661,2.6,1.406,1.406,0,1,1,30.152.214,13.031,13.031,0,0,1,36.437,11.25a13.03,13.03,0,0,1-6.285,11.035,1.4,1.4,0,0,1-.745.214",
  transform: "translate(-8.313 0)"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_5535",
  "data-name": "Path 5535",
  d: "M7.03,22.5a1.4,1.4,0,0,1-.745-.214A13.03,13.03,0,0,1,0,11.25,13.031,13.031,0,0,1,6.285.214,1.406,1.406,0,1,1,7.777,2.6,10.239,10.239,0,0,0,2.812,11.25,10.238,10.238,0,0,0,7.777,19.9a1.406,1.406,0,0,1-.747,2.6",
  transform: "translate(0 0)"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_5536",
  "data-name": "Path 5536",
  d: "M12.217,20.063a1.4,1.4,0,0,1-.844-.282,8.438,8.438,0,0,1,0-13.5,1.407,1.407,0,1,1,1.69,2.249,5.624,5.624,0,0,0,0,9,1.406,1.406,0,0,1-.847,2.531",
  transform: "translate(-2.375 -1.781)"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_5537",
  "data-name": "Path 5537",
  d: "M25.407,20.062a1.406,1.406,0,0,1-.847-2.531,5.624,5.624,0,0,0,0-9,1.407,1.407,0,0,1,1.69-2.249,8.438,8.438,0,0,1,0,13.5,1.4,1.4,0,0,1-.844.282",
  transform: "translate(-7.125 -1.781)"
})))));
export default SvgIconChannel;